import PaymentIcon from "@mui/icons-material/Payment";

import { FormattedMessage, useIntl } from "react-intl";

const usePaymentItems = () => {
  const icons = {
    PaymentIcon,
  };

  const paymeItems = {
    id: "group-payment",
    title: (
      <FormattedMessage id="Payment Management">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    icon: icons.PaymentIcon,
    // url: "/payment",
    type: "group",
    children: [
      {
        id: "payment",
        title: <FormattedMessage id="Payment List" />,
        type: "item",
        url: "/payment",
        icon: icons.PaymentIcon,
        breadcrumbs: false,
      },
    ],
  };

  return paymeItems;
};

export default usePaymentItems;
